<div class="card" (click)="onClickCardPicture()">
    <div class="image-wrapper">
        <img
            [src]="card.picture"
            alt="Random first slide"
            class="card-img-top img-fluid main-image"
        />
    </div>
    <div
        class="card-footer"
        [ngClass]="{
            visual: card.rootObj.containerType === 'PROJECT_VISUAL',
            motoric: card.rootObj.containerType === 'PROJECT_MOTORIC',
            imageDb: card.rootObj.containerType === ContainerType.IMAGE_DB,
        }"
    >
        <div class="left-side">
            <div class="user-profile-img float-start">
                <img
                    [src]="
                        card.footer.userProfilePicture
                            ? card.footer.userProfilePicture
                            : 'assets/img/card-icons/default-profile-image.jpg'
                    "
                    class="card-user-img"
                    alt="profile image"
                />
            </div>
            <a class="project-name float-start" [title]="card.footer.title">
                {{ card.footer.title }}
            </a>
        </div>
        <div class="right-side">
            <img
                *ngIf="!card.options?.hideDeleteButton"
                class="delete-button"
                (click)="onDeleteButtonClick($event)"
                [ngClass]="{ disabled: card.options?.disableDeleteButton }"
                [title]="
                    card.options?.disableDeleteButton
                        ? ('card.components.card.deleteTooltip' | translate)
                        : ''
                "
                src="assets/svg/reusable-svg/icon-trash-can-hover.svg"
                alt="delete"
            />
        </div>
    </div>
    <div
        class="badge"
        [ngClass]="{
            owner: card.rootObj.membershipStatus === 'OWNER',
            member: card.rootObj.membershipStatus === 'MEMBER',
            requested: card.rootObj.membershipStatus === 'REQUESTED',
            visual: card.rootObj.containerType === 'PROJECT_VISUAL',
            motoric: card.rootObj.containerType === 'PROJECT_MOTORIC',
            imageDb: card.rootObj.containerType === ContainerType.IMAGE_DB,
        }"
        *ngIf="card.rootObj && card.rootObj.membershipStatus !== 'NONE'"
    >
        <div class="text">
            <span>{{
                'card.membershipStatus.' + card.rootObj.membershipStatus
                    | translate
            }}</span>
        </div>
    </div>
</div>
